import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../../../styles/ag-grid.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, SelectionChangedEvent } from 'ag-grid-community';
import { FEDERATION_WILLCONNECT_TABLE_COLUMN } from './columns';
import { IfedListItem } from '../../../interfaces/api/service-provider/I-api-admin-serviceProvider-fed';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import DownTopBar from '../../mainPage/federation-management/DownTopBar';
import { setSelectedOtherFederation } from '../../../redux/slice/federatinManagementSlice';

const FederationWillConnect_Table = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { otherFedList, selectedOtherFederation } = useAppSelector(
    (state) => state.federatinManagement,
  );

  // AG_GRID
  const gridRef = useRef<any>(null);

  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);
  // const [columnDefs, setColumnDefs] = useState<ColDef[]>(
  //   FEDERATION_WILLCONNECT_TABLE_COLUMN,
  // );

  const [rowData, setRowData] = useState<IfedListItem[]>([]);
  const defaultColDef = useMemo<ColDef>(() => {
    return {
      flex: 1,
      resizable: true,
      minWidth: 100,
    };
  }, []);

  const onSelectionChanged = useCallback(
    (props: SelectionChangedEvent<IfedListItem>) => {
      if (!gridRef) return;

      // const selectedRows: IfedListItem[] = gridRef.current.api.getSelectedRows();
      const selectedRows = props.api.getSelectedRows();

      // console.log('selectedRows', selectedRows);

      if (selectedRows.length < 1) {
        dispatch(setSelectedOtherFederation(null));
      } else {
        dispatch(setSelectedOtherFederation(selectedRows[0]));
      }
    },
    [],
  );

  // set-ROWDATA
  useEffect(() => {
    if (otherFedList.length < 1) {
      setRowData([]);
      return;
    }

    setRowData(otherFedList);
  }, [otherFedList]);

  useEffect(() => {
    setColumnDefs(FEDERATION_WILLCONNECT_TABLE_COLUMN(t));
  }, [t]);

  return (
    <div className="w-full grow pb-2 flex flex-col overflow-hidden">
      {selectedOtherFederation &&
        selectedOtherFederation.status !== 0 &&
        selectedOtherFederation.status !== 3 &&
        selectedOtherFederation.status !== 4 &&
        selectedOtherFederation.status !== 7 &&
        selectedOtherFederation.status !== 8 && <DownTopBar />}
      <div className="ag-theme-alpine ag-theme-mycustomtheme w-full grow">
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onSelectionChanged={onSelectionChanged}
          rowMultiSelectWithClick
          rowSelection={'single'}
          overlayNoRowsTemplate={'\xa0'}
        ></AgGridReact>
      </div>
    </div>
  );
};

export default FederationWillConnect_Table;
